import delegate from "delegate-it";
import { setupForms } from "@/scripts/components/form/form";
import {
  setupMultistepForm,
  setupHistoryListener,
  setupStepLinkListener,
} from "@/scripts/components/form/multistep-form";

const handleLoadStep = () => {
  setupForms();

  document.querySelectorAll(".multistep-form").forEach((form) => {
    setupMultistepForm(form);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".multistep-form-page")) {
    return;
  }

  document.querySelectorAll(".multistep-form").forEach((form) => {
    setupMultistepForm(form);
  });

  setupHistoryListener();
  setupStepLinkListener();

  const url = new URL(window.location.href);
  if (url.pathname.includes("/practice-information")) {
    url.pathname = "";
    window.history.replaceState({}, "", url.toString());
  }

  delegate("html", "multistep-form:load", handleLoadStep);
});
